import { render } from "./CustomQuill.vue?vue&type=template&id=10d09a7e"
import script from "./CustomQuill.vue?vue&type=script&lang=js"
export * from "./CustomQuill.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__